import React, { useEffect } from 'react';
import styles from './Skills.module.css';
import Title from '../helper/Title';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Courousel from '../helper/Courousel'

// aos animasyon  
const Skills = () => {
  useEffect(() => {
    AOS.init({ 
      offset: 60,
      duration: 1000, 
      easing: 'ease', 
      once: false 
    });

    window.addEventListener('scroll', () => {
      AOS.refresh();
    });

    return () => {
      window.removeEventListener('scroll', () => {
        AOS.refresh();
      });
    };
  }, []);


  // drid yapısı
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));

  return (
    <section className={styles.section} id="skills">
      <Title className={styles.sectiontitle} title='Skills' subTitle='-' />

      <Box sx={{ width: '100%' }}>
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md:3, lg:4 }}>
        <Grid item lg={6} md={6} xs={12} sm={12}>
          <Item style={{ boxShadow: 'none', textAlign:'start', fontWeight:'bold', fontSize:'1rem'}}>

        {/* HTML ilerleme çubuğu */}
        <div data-aos="fade-in" data-aos-duration="1000">
          <i>HTML</i>
          <div className={`${styles.progress}`}>
            <div className={`${styles['progress-bar']} ${styles['progress-bar-striped']} ${styles['progress-bar-animated']}`} role="progressbar" aria-label="HTML" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style={{ width: '60%' }}></div>
          </div>
        </div>

        {/* CSS ilerleme çubuğu */}
        <div data-aos="fade-in" data-aos-duration="1300">
          <i>CSS</i>
          <div className={`${styles.progress}`}>
            <div className={`${styles['progress-bar']} ${styles['progress-bar-striped']} ${styles['progress-bar-animated']}`} role="progressbar" aria-label="CSS" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style={{ width: '50%' }}></div>
          </div>
        </div>

        {/* Bootstrap ilerleme çubuğu */}
        <div data-aos="fade-in" data-aos-duration="1600">
          <i>Bootstrap</i>
          <div className={`${styles.progress}`}>
            <div className={`${styles['progress-bar']} ${styles['progress-bar-striped']} ${styles['progress-bar-animated']}`} role="progressbar" aria-label="Bootstrap" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style={{ width: '50%' }}></div>
          </div>
        </div>

        {/* JavaScript ilerleme çubuğu */}
        <div data-aos="fade-in" data-aos-duration="1900">
          <i>JavaScript</i>
          <div className={`${styles.progress}`}>
            <div className={`${styles['progress-bar']} ${styles['progress-bar-striped']} ${styles['progress-bar-animated']}`} role="progressbar" aria-label="JavaScript" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100" style={{ width: '25%' }}></div>
          </div>
        </div>

         {/* React JS */}
         <div data-aos="fade-in" data-aos-duration="2200">
          <i>React.Js</i>
          <div className={`${styles.progress}`}>
            <div className={`${styles['progress-bar']} ${styles['progress-bar-striped']} ${styles['progress-bar-animated']}`} role="progressbar" aria-label="Git-Github" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style={{ width: '40%' }}></div>
          </div>
        </div>

        {/* Python ilerleme çubuğu */}
        <div data-aos="fade-in" data-aos-duration="2500">
          <i>Python</i>
          <div className={`${styles.progress}`}>
            <div className={`${styles['progress-bar']} ${styles['progress-bar-striped']} ${styles['progress-bar-animated']}`} role="progressbar" aria-label="Python" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100" style={{ width: '15%' }}></div>
          </div>
        </div>

        {/* Django ilerleme çubuğu */}
        <div data-aos="fade-in" data-aos-duration="2800">
          <i>Django</i>
          <div className={`${styles.progress}`}>
            <div className={`${styles['progress-bar']} ${styles['progress-bar-striped']} ${styles['progress-bar-animated']}`} role="progressbar" aria-label="Django" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style={{ width: '15%' }}></div>
          </div>
        </div>

        {/* Git-Github ilerleme çubuğu */}
        <div data-aos="fade-in" data-aos-duration="3100">
          <i>Git-Github</i>
          <div className={`${styles.progress}`}>
            <div className={`${styles['progress-bar']} ${styles['progress-bar-striped']} ${styles['progress-bar-animated']}`} role="progressbar" aria-label="Git-Github" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style={{ width: '50%' }}></div>
          </div>
        </div>

        
          </Item>
        </Grid>
        <Grid item lg={6} md={6} xs={12} sm={12}>
          <Item className={styles.slider} style={{ boxShadow: 'none', textAlign:'center', alignItems:'center', fontWeight:'bold', fontSize:'1rem' }}>
            <Courousel />
          </Item>
        </Grid>
      </Grid>
      </Box>
      
      </section>
     
    
  );
};

export default Skills;
